var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 0.0625C4.56375 0.0625 0.5625 4.06375 0.5625 9C0.5625 13.9363 4.56375 17.9375 9.5 17.9375C14.4363 17.9375 18.4375 13.9363 18.4375 9C18.4375 4.06375 14.4363 0.0625 9.5 0.0625ZM10.1875 6.25C10.1875 6.06766 10.1151 5.8928 9.98614 5.76386C9.8572 5.63493 9.68234 5.5625 9.5 5.5625C9.31766 5.5625 9.1428 5.63493 9.01386 5.76386C8.88493 5.8928 8.8125 6.06766 8.8125 6.25V8.3125H6.75C6.56766 8.3125 6.3928 8.38493 6.26386 8.51386C6.13493 8.6428 6.0625 8.81766 6.0625 9C6.0625 9.18234 6.13493 9.3572 6.26386 9.48614C6.3928 9.61507 6.56766 9.6875 6.75 9.6875H8.8125V11.75C8.8125 11.9323 8.88493 12.1072 9.01386 12.2361C9.1428 12.3651 9.31766 12.4375 9.5 12.4375C9.68234 12.4375 9.8572 12.3651 9.98614 12.2361C10.1151 12.1072 10.1875 11.9323 10.1875 11.75V9.6875H12.25C12.4323 9.6875 12.6072 9.61507 12.7361 9.48614C12.8651 9.3572 12.9375 9.18234 12.9375 9C12.9375 8.81766 12.8651 8.6428 12.7361 8.51386C12.6072 8.38493 12.4323 8.3125 12.25 8.3125H10.1875V6.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.8a4ecfed1f0b5037a2f3b0e03ef839fb.svg";
export { ForwardRef as ReactComponent };